module.exports = __webpack_public_path__ + "img/left.3de9e481.png";